// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"dc3cb7fa","971":"eece30ad"}[chunkId] + ".chunk.js";
};